import type { UserRole } from '@/types';
import { STATIC_CHAT_HISTORY_BY_ROLE, type SidebarStaticHistory } from '@/config/static/workspace';

export function getStaticChatHistory(role: UserRole): SidebarStaticHistory[] {
  return STATIC_CHAT_HISTORY_BY_ROLE[role] ?? [];
}
